import { combineReducers } from 'redux';
import raffleAvailableTabsReducer from './raffleAvailableTabsReducer';
import rafflePageDataReducer from './rafflePageDataReducer';
import rafflePrizeDataReducer from './rafflePrizeDataReducer';
import raffleMyTicketsReducer from './raffleMyTicketsReducer';
import raffleSerialDataReducer from './raffleSerialDataReducer';
import raffleResultDrawsReducer from './raffleResultDrawsReducer';
import raffleOneOfSerialReducer from './raffleOneOfSerialReducer';
import raffleResultDrawActiveReducer from './raffleResultDrawActiveReducer';
import raffleSlipReducer from './raffleSlipReducer';
import raffleSpecialDataReducer from './raffleSpecialDataReducer';
import raffleQueryResultReducer from './raffleQueryResultReducer';
import raffleBuyDataReducer from './raffleBuyDataReducer';
import raffleRenderReducer from './raffleRendererReducer';

export default combineReducers({
  raffleAvailableTabs: raffleAvailableTabsReducer,
  rafflePageData: rafflePageDataReducer,
  rafflePrizeData: rafflePrizeDataReducer,
  raffleMyTickets: raffleMyTicketsReducer,
  raffleSerialData: raffleSerialDataReducer,
  raffleSpecialData: raffleSpecialDataReducer,
  raffleResultDraws: raffleResultDrawsReducer,
  raffleOneOfSerial: raffleOneOfSerialReducer,
  raffleResultDrawActive: raffleResultDrawActiveReducer,
  raffleQueryResult: raffleQueryResultReducer,
  raffleSlipData: raffleSlipReducer,
  raffleBuyData: raffleBuyDataReducer,
  raffleRenderer: raffleRenderReducer
});
